import { DefaultLayout as Layout } from '../../../layouts/Default/DefaultLayout';
import { useStoreContext } from '../../../store/store';
import { Helpers } from '../../../utils/helpers';

export const StateViewerPage = () => {
  const { user, settings } = useStoreContext();

  return (
    <Layout>
      <h1>State Viewer</h1>
      <div className="row">
        <div className="col-7">
          <h2>User State</h2>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Property</th>
                <th scope="col">Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>UserId</td>
                <td>{user.userId}</td>
              </tr>
              <tr>
                <td>UserName</td>
                <td>{user.userName}</td>
              </tr>
              <tr>
                <td>Permissions</td>
                <td>
                  <div className="row">
                    {user.permissions.sort().map((permission) => {
                      return (
                        <div className="col-4" key={permission}>
                          {permission}
                        </div>
                      );
                    })}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  Token
                  <div>{Helpers.toFileSizeText(user.token?.length ?? 0)}</div>
                </td>
                <td className="text-break">{user.token}</td>
              </tr>
              <tr>
                <td className="text-nowrap">Token Expires</td>
                <td>{user.expiresAt ? Helpers.toShortDateTime(user.expiresAt) : '---'}</td>
              </tr>
              <tr>
                <td className="text-nowrap">Token Refresh</td>
                <td>{user.refreshAt ? Helpers.toShortDateTime(user.refreshAt) : '---'}</td>
              </tr>
              <tr>
                <td className="text-nowrap">Last Api Activity</td>
                <td>
                  {user.lastApiActivity ? Helpers.toShortDateTime(user.lastApiActivity) : '---'}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-5">
          <h2>App Settings State</h2>
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Property</th>
                <th scope="col">Value</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>isLoading</td>
                <td>{settings.isLoading ? 'True' : 'False'}</td>
              </tr>
              <tr>
                <td>apiReady</td>
                <td>{settings.apiReady ? 'True' : 'False'}</td>
              </tr>
              <tr>
                <td>applicationReady</td>
                <td>{settings.applicationReady ? 'True' : 'False'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
};
